export function headerNav() {
  document.addEventListener('DOMContentLoaded', () => {
    const navToggle = document.querySelector('.js-headerNav-toggle');
    const headerNav = document.querySelector('.js-headerNav');

    if (navToggle && headerNav) {
      navToggle.addEventListener('click', () => {
        navToggle.classList.toggle('is-show');
        headerNav.classList.toggle('is-show');
      });
    }
  });
}